'use client';

import React from 'react';
import { Zap, Users, BarChart2, Clock } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';

interface StatItem {
  id: string;
  label: string;
  IconComponent: React.ElementType;
  color: string;
  source: string;
}

const stats: StatItem[] = [
  {
    id: 'gov-stat-active',
    label: 'Active Proposals',
    IconComponent: Zap,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Database',
  },
  {
    id: 'gov-stat-quorum',
    label: 'Avg Quorum Rate',
    IconComponent: BarChart2,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Database',
  },
  {
    id: 'gov-stat-voters',
    label: 'Unique Voters (30d)',
    IconComponent: Users,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Database',
  },
  {
    id: 'gov-stat-period',
    label: 'Voting Period',
    IconComponent: Clock,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Database',
  },
];

export default function GovernanceStats() {
  return (
    <div data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:48:4" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="48" data-component-end-line="73" data-component-file="GovernanceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((s) => {
        const Icon = s.IconComponent;
        return (
          <div data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:52:10" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="52" data-component-end-line="70" data-component-file="GovernanceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border%20border-border%20rounded-xl%20p-4%20flex%20items-center%20gap-3%22%7D"
            key={s.id}
            className="bg-card border border-border rounded-xl p-4 flex items-center gap-3"
          >
            <div data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:56:12" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="56" data-component-end-line="60" data-component-file="GovernanceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${s.color}`}
            >
              <Icon data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:59:14" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="59" data-component-end-line="59" data-component-file="GovernanceStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" size={16} />
            </div>
            <div data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:61:12" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="61" data-component-end-line="69" data-component-file="GovernanceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
              <p data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:62:14" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="62" data-component-end-line="64" data-component-file="GovernanceStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-2xs%20text-muted-foreground%20uppercase%20tracking-wide%20font-medium%22%7D" className="text-2xs text-muted-foreground uppercase tracking-wide font-medium">
                {s.label}
              </p>
              <p data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:65:14" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="65" data-component-end-line="67" data-component-file="GovernanceStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-bold%20tabular-nums%20text-muted-foreground%20italic%22%2C%22textContent%22%3A%22Waiting%20for%20Real%20Data%22%7D" className="text-sm font-bold tabular-nums text-muted-foreground italic">
                Waiting for Real Data
              </p>
              <p data-component-id="src/app/governance-dashboard/components/GovernanceStats.tsx:68:14" data-component-path="src/app/governance-dashboard/components/GovernanceStats.tsx" data-component-line="68" data-component-end-line="68" data-component-file="GovernanceStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-2xs%20text-muted-foreground%2F60%22%7D" className="text-2xs text-muted-foreground/60">{s.source}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
